<template>
  <section style="text-align: left">
    <div>
      <div style="margin-bottom: 50px; text-align: center">
        <h1>AXESA DIGITAL MARKETING AND MEDIA (AXESA)</h1>
        <p>
          AXESA ES UN NEGOCIO, PRODUCTO, EMPRESA, PRODUCTO Y MARCA EXCLUSIVA DE
          CMI DIGITAL MEDIA, LLC.
        </p>
      </div>

      <div class="policy-title">
        <h2>Política de privacidad</h2>
        <small>
          Fecha de entrada en vigor: 15 de abril de 2024.
        </small>
      </div>

      <div class="concept">
        <p>
          En Axesa Digital Marketing and Media, respetamos su derecho a mantener
          su información personal privada. Escribimos esta Política de
          Privacidad (Política) para asegurarnos de que comprende el tipo de
          información que recopilamos, cuándo la recopilamos, cómo la usamos y,
          finalmente, sus derechos para acceder a ella.
        </p>
        <p>
          Axesa Digital Marketing and Media, junto con sus filiales, (Axesa)
          (nosotros), ha creado esta Política firmemente comprometida con la
          protección de su privacidad. Esta Política establece cómo recopilamos,
          usamos y aseguramos la información personal de las personas que
          utilizan cualquier sitio web, producto o servicio digital de nuestra
          propiedad. Esta Política refleja los requisitos de la legislación de
          privacidad aplicable, así como nuestro compromiso continuo de proteger
          su información personal.
        </p>
        <div class="caution-box">
          <p class="title">
            ¡Por favor, lea esta Política cuidadosamente!
          </p>
          <p class="text">
            AL UTILIZAR EL SITIO WEB, LOS PRODUCTOS Y LOS SERVICIOS DE AXESA,
            USTED ACEPTA ESTAR SUJETO A LA SIGUIENTE POLÍTICA DE PRIVACIDAD. SI
            NO ESTÁ DE ACUERDO CON ESTA POLÍTICA, SUSPENDA TODO USO DE ESTE
            SITIO, PRODUCTO O SERVICIO DE INMEDIATO.
          </p>
        </div>
      </div>

      <div class="clauses">
        <div>
          <h3>
            <span>A.</span>
            Información personal o información de identificación personal
          </h3>
          <p>
            La información personal o información de identificación personal es
            información sobre usted que lo identifica de manera única como
            individuo. Su nombre, dirección, dirección de correo electrónico,
            número de teléfono, su información de contacto, su ubicación (basada
            en IP) y su información de envío son ejemplos de información
            personal. Sin embargo, el nombre, la dirección y el número de
            teléfono de una persona que aparece en un directorio, digital o
            impreso, que está disponible para el público no cae bajo el alcance
            de la información personal o la información de identificación
            personal, ya que es información disponible públicamente. Además, en
            algunas circunstancias, parte de esta información puede calificar
            como información comercial que no está cubierta por esta Política.
          </p>
        </div>

        <div>
          <h3>
            <span>B.</span>
            Recopilación de información personal o información de identificación
            personal e información de identificación no personal
          </h3>
          <p>
            No recopilamos automáticamente ninguna información personal de los
            usuarios de sitios web, productos y servicios digitales. La
            información personal o de identificación personal solo se obtiene si
            la proporciona voluntariamente, generalmente a través de la compra
            de productos y servicios, cuando crea una cuenta, cuando se suscribe
            a nuestro boletín informativo por correo electrónico, cuando se
            comunica con nosotros por correo electrónico, cuando se registra
            para un seminario web / demostración, cuando se registra para
            participar en una conferencia telefónica o asiste a un evento,
            cuando llama a nuestro personal y proporciona cualquier información
            de identificación personal por teléfono a un empleado o contratista
            de Axesa, cuando solicita en línea un concurso, responde encuestas
            en línea, envía una publicación a un blog, foro o revisión o se
            registra para los servicios.
          </p>
          <p>
            Además, podemos combinar la información de identificación personal y
            la información de identificación no personal que recopilamos de
            usted con información adicional proporcionada por terceros (como
            registrarse o vincular una cuenta de Google o Facebook, o agregar
            datos de 3 ª parte). No está obligado(a) a proporcionar información
            personal para ver el contenido de ningún sitio web o medio digital
            de Axesa. También debe tener en cuenta que cuando comparte
            información personal en áreas públicas de un sitio web o medio
            digital de Axesa, esta información puede ser vista y utilizada por
            otros usuarios. Le instamos a que ejerza un buen juicio al compartir
            información personal en estas áreas y/o en aplicaciones que utilicen
            y/o se programen mediante inteligencia artificial.
          </p>
          <p>
            Si decide no proporcionarnos información personal en línea, no se
            producirán consecuencias materiales, aunque es posible que no pueda
            participar en ciertas promociones, recibir información de productos
            o utilizar partes del sitio web, productos y servicios de Axesa que
            requieran información o aplicaciones personalizadas. Los sitios web
            de Axesa y los medios, productos y/o servicios digitales aplicables
            brindan a los usuarios la oportunidad de optar por no recibir
            nuestras comunicaciones en el momento en que solicitamos información
            de contacto sobre usted.
            <span style="text-decoration: underline;">
              La oportunidad de optar no es aplicable a las comunicaciones y/o
              esfuerzos de cobro a clientes y anunciantes contratantes.</span
            >
          </p>
          <p>
            La información de identificación no personal es información que no
            se puede asociar directamente con usted. Recopilamos automáticamente
            cierta información de identificación no personal cuando utiliza
            nuestros servicios. Por ejemplo, recopilamos información sobre los
            dispositivos que utiliza para conectarse a nuestros servicios (como
            la dirección IP de su ordenador o el identificador numérico de su
            dispositivo móvil) y sobre cómo utiliza los servicios de Axesa (como
            la hora del día en que visita nuestro sitio web). Nuestros
            anunciantes y/o administradores de anuncios también pueden recopilar
            información de identificación no personal fuera del sitio web,
            productos y servicios de Axesa para medir el éxito de nuestras
            campañas de publicidad digital. Utilizamos la información de
            identificación no personal que recopilamos para una variedad de
            propósitos, como proporcionar y mejorar la experiencia y los
            servicios del usuario, y analizar y mejorar nuestra publicidad para
            proporcionar los mensajes más relevantes a nuestros clientes
            actuales y potenciales.
          </p>
          <p>
            Los sitios web, medios digitales, productos y servicios de Axesa
            pueden utilizar “cookies” para rastrear los patrones de tráfico de
            los usuarios. Una “cookie” es un pequeño archivo de datos que
            ciertos sitios web escriben en su disco duro cuando los visita. La
            única información personal que puede contener una “cookie” es la
            información que usted mismo proporciona. Una “cookie” no puede leer
            datos de su disco duro o archivos de “cookies” creados por otros
            sitios web. Axesa no correlaciona esta información con datos sobre
            usuarios individuales, ni comparte esta información ni la vende a
            terceros. Solo utilizamos “cookies” para adaptar la experiencia del
            visitante a los sitios web, productos digitales y servicios de
            Axesa. Si prefiere no recibir “cookies” de Axesa, puede configurar
            su navegador para que le avise antes de aceptar “cookies” y rechazar
            la “cookie” cuando su navegador le avise de su presencia. También
            puede rechazar todas las “cookies” desactivándolas en su navegador.
          </p>
          <p>
            Podemos utilizar “software” que reciba y registre la dirección de
            Protocolo de Internet del ordenador que ha contactado con el medio
            digital o el sitio web de Axesa. No intentamos vincular estas
            direcciones con la identidad de las personas que visitan nuestros
            sitios web. También podemos utilizar proveedores de servicios para
            publicar anuncios de terceros en los medios digitales de Axesa y
            anuncios en otros sitios web. Al publicar anuncios, estos
            proveedores pueden colocar “cookies” en su computadora navegador y
            pueden recopilar cierta información anónima sobre sus visitas a
            otros sitios web o en los medios digitales de Axesa. Esta
            información puede incluir el tipo de navegador, la dirección IP, el
            nombre de dominio y el nombre de la página web desde la que ingresó
            a dichos sitios web, la actividad web y la hora del día. Esta
            información es utilizada por estos terceros para comprender mejor y
            optimizar las campañas de publicidad en línea.
          </p>
          <p>
            La información personal que recopilamos se utiliza para
            proporcionar, analizar y mejorar nuestros servicios (por ejemplo,
            procesos, ofertas, responder a solicitudes de clientes, realizar
            cambios en los compromisos contractuales existentes, etc.) y para
            realizar marketing en medios impresos y digitales. Si se suscribe
            voluntariamente ("opt in") a nuestra lista de correo electrónico, le
            enviaremos correos electrónicos periódicos sobre una variedad de
            temas que incluyen, entre otros: productos, servicios, eventos,
            contenido nuevo, actualizaciones de productos, contenido de blog,
            actualizaciones de la compañía, oportunidades de empleo, etc. Si un
            consumidor desea "optar por no compartir" este intercambio, ese
            consumidor simplemente debe optar por no recibir correos
            electrónicos de mercadeo de nosotros y será eliminado de inmediato
            de todas las listas de correo electrónico. Hay un enlace para darse
            de baja en la parte inferior de cada correo electrónico que enviamos
            o puede comunicarse con Axesa a:
            <a href="mailto:customerservice@axesa.com">
              customerservice@axesa.com</a
            >
          </p>
          <p>
            Si bien nunca recopilaríamos u obtendríamos conscientemente datos
            sobre nuestros clientes de manera poco ética, no seremos
            responsables si obtenemos inadvertidamente datos de una fuente de
            terceros que se recopilaron de manera poco ética. Sin embargo, si
            nos enteramos de que cualquier información personal de terceros se
            recopiló de manera poco ética, dejaremos de usar dichos datos y
            tomaremos medidas para evitar que recopilemos esa información
            personal nuevamente. Por favor contáctenos a:
            <a href="mailto:customerservice@axesa.com">
              customerservice@axesa.com</a
            >. Si cree que su información personal fue proporcionada o
            recopilada por un tercero de una manera poco ética.
          </p>
          <p>
            Finalmente, no recopilaremos su información personal a menos que nos
            dé su consentimiento expreso o implícito para así hacerlo.
          </p>
        </div>

        <div>
          <h3>
            <span>C.</span>
            Uso y uso compartido de información personal
          </h3>
          <p>
            Por lo general, recopilaremos y utilizaremos información personal
            para administrar nuestros medios digitales, productos, servicios,
            concursos, promociones, encuestas, programas de recompensas y otros
            servicios, para comprender las respuestas, necesidades y
            preferencias de nuestros clientes y, en general, para administrar
            nuestro negocio.
          </p>
          <p>
            También podemos usar información personal para contactar a nuestros
            clientes o proveedores con materiales de mercadeo o promocionales
            sobre nuestros productos, programas y servicios o para ayudar a
            nuestro personal a proporcionar ofertas de ventas personalizadas a
            nuestros clientes. Podemos intercambiar o fusionar información
            personal con datos obtenidos de terceros para los mismos fines.
          </p>
          <p>
            La información personal puede ser compartida con nuestros agentes,
            representantes, empleados, oficiales o contratistas en relación con
            los servicios que realizan para nosotros. Nuestros acuerdos escritos
            con dichos agentes, representantes, empleados, oficiales y
            contratistas garantizan que la información personal solo se pueda
            usar para los fines para los que se compartió con ellos, y que
            manejen la información personal de acuerdo con esta Política.
            Algunos de nuestros agentes, representantes, empleados, oficiales y
            contratistas se encuentran fuera de Puerto Rico y, como tales, están
            sujetos a leyes extranjeras, incluidas las leyes que pueden requerir
            la divulgación de información personal a agencias gubernamentales en
            esos países.
          </p>
          <p>
            No divulgamos su información de identificación personal a terceros,
            excepto de la siguiente manera. En todos los casos, se le notificará
            y se le dará la oportunidad de decidir si desea compartir su
            información de identificación personal:
          </p>
          <ul>
            <li>
              A compañías que nos brindan servicios o realizan funciones en
              nuestro nombre (como procesar pagos con tarjeta de crédito o tomar
              ordenes de servicio) y han acordado usar su información solo para
              los fines que solicitamos;
            </li>
            <li>
              Para que enviemos ofertas a nuestros clientes en nombre de
              nuestras compañías afiliadas y en nombre de otros socios no
              afiliados;
            </li>
            <li>
              A otras compañías acreditadas seleccionadas, podemos divulgar su
              nombre y dirección postal (pero no su dirección de correo
              electrónico o información de tarjeta de crédito) para que puedan
              enviarle por correo información que pueda interesarle;
            </li>
            <li>
              Cuando creamos que la divulgación es necesaria para cumplir con la
              ley aplicable, el proceso legal y / o las autoridades
              gubernamentales;
            </li>
            <li>
              Cuando creamos que la divulgación es necesaria para hacer cumplir
              nuestra política de privacidad y otros acuerdos, o para proteger
              nuestros derechos, nuestros clientes, nuestra propiedad, nuestros
              empleados u otros;
            </li>
            <li>
              Si estamos involucrados en una fusión, adquisición, quiebra, venta
              parcial o total de activos, u otro cambio corporativo.
            </li>
          </ul>
          <p>
            Por las razones mencionadas anteriormente en esta Política de
            Privacidad, podemos divulgar información no identificable, agregada
            u otra información de identificación no personal a terceros.
          </p>
        </div>

        <div>
          <h3>
            <span>D.</span>
            Enlaces a terceros y redes sociales
          </h3>
          <p>
            Nuestro sitio web y medios digitales pueden contener enlaces a
            terceros en línea. Dichos terceros tienen sus propias políticas que
            rigen su recopilación, uso y divulgación de información. Le
            sugerimos que lea sus políticas de privacidad para conocer sus
            prácticas.
          </p>
          <p>
            Las redes sociales proporcionan herramientas que muchos de nuestros
            clientes usan y disfrutan, e incluimos enlaces a varias plataformas
            de redes sociales en nuestros sitios web y productos digitales. Si
            interactúa con estas herramientas de redes sociales a través de
            nuestros sitios web, su experiencia en esos sitios de redes sociales
            se regirá por las políticas de privacidad y otras políticas de
            dichas redes o sitios. Por lo tanto, la configuración de privacidad
            que haya elegido en esos sitios determinará el grado en que su
            información se hace pública. Le recomendamos que revise las
            políticas de privacidad de cada sitio de redes sociales antes de
            usar sus servicios y que ajuste su configuración de privacidad en
            cada sitio de acuerdo con sus deseos individuales.
          </p>
        </div>

        <div>
          <h3>
            <span>E.</span>
            Su consentimiento
          </h3>
          <p>
            Al proporcionarnos su información personal, usted acepta que
            recopilemos, usemos y divulguemos esa información como se describe
            en esta Política, según se modifique de vez en cuando o como se
            describe en o antes del momento de la recopilación, uso o
            divulgación, según sea el caso. Si no desea que su información
            personal sea recopilada, utilizada o divulgada de esta manera, por
            favor:
          </p>
          <p>
            Si nos ha enviado información personal y desea retirar su
            consentimiento para su retención, uso o divulgación, envíe un correo
            electrónico a
            <a href="mailto:customerservice@axesa.com">
              customerservice@axesa.com</a
            >. Puede retirar su consentimiento, sujeto a restricciones legales o
            contractuales y a un aviso razonable. Si retira su consentimiento,
            es posible que no podamos proporcionarle algunos productos o
            servicios.
          </p>
          <p>
            Cuando lo permita o exija la ley, podemos recopilar, usar o divulgar
            su información personal sin su consentimiento, por ejemplo, para
            cobrar una deuda que nos debe, para cumplir con una investigación
            legalmente permitida por una agencia gubernamental o para cumplir
            con una orden judicial.
          </p>
        </div>

        <div>
          <h3>
            <span>F.</span>
            Salvaguardas
          </h3>
          <p>
            Utilizamos medidas de seguridad físicas, organizativas y
            tecnológicas para proteger su información personal contra robo,
            pérdida o acceso, uso, modificación, divulgación o eliminación no
            autorizados. Sin embargo, dado que los datos enviados
            electrónicamente no son 100% seguros, no ofrecemos garantías en
            cuanto a la seguridad de cualquier información personal que envíe en
            línea, lo que hace bajo su propio riesgo.
          </p>
        </div>

        <div>
          <h3>
            <span>G.</span>
            Términos de uso y cambios a esta Política
          </h3>
          <p>
            Su uso de los sitios web, medios digitales, productos, servicios de
            Axesa y cualquier disputa que surja de ellos, está sujeto a esta
            Política y se rige por nuestros Términos de uso, incluidas sus
            disposiciones de elección de ley. Nos reservamos el derecho de
            cambiar y actualizar la Política y estos cambios se realizarán
            cuando corresponda, de manera oportuna. Le recomendamos que examine
            nuestra Política de vez en cuando para asegurarse de que está al
            tanto de cualquier cambio que podamos haber realizado.
          </p>
        </div>

        <div>
          <h3>
            <span>H.</span>
            Acceso y Contacto
          </h3>
          <p>
            Previa solicitud por escrito, Axesa le proporcionará acceso a su
            información personal, sujeto a ciertas excepciones según lo
            dispuesto por la legislación aplicable. Si observa algún error u
            omisión en su información personal, avísenos por escrito y lo
            corregiremos de inmediato cuando corresponda. Si tiene inquietudes
            con respecto a nuestra Política, la seguridad de su información
            personal o nuestro cumplimiento con la legislación de protección de
            información personal aplicable envíe una breve explicación de su
            inquietud a:
            <a href="mailto:customerservice@axesa.com">
              customerservice@axesa.com</a
            >.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "policy-axesa"
};
</script>
<style lang="scss" scoped>
.policy-title {
  margin-bottom: 30px;
  h2 {
    font-size: 1.3rem;
    font-weight: 600;
  }
}

.concept {
  p {
    margin-bottom: 20px;
  }
  .caution-box {
    padding: 20px;
    border-radius: 25px;
    margin: 30px 0;
    background-color: #f5f5f5;
    .title {
      font-size: 1rem;
      font-weight: 600;
      color: #333333;
    }
    .text {
      color: #3c3c3c;
      margin-bottom: 0px;
      font-weight: 500;
    }
  }
}

.clauses {
  div {
    margin: 20px 0;
    h3 {
      margin-bottom: 10px;
      span {
        /*display: inline-block;
                background-color: #f5f5f5;
                border-radius: 200px;
                padding: 8px;*/
        font-weight: 600;
      }
    }
    p,
    ul {
      margin-left: 30px;
      margin-bottom: 20px;
      li {
        margin-left: 20px;
        margin-bottom: 10px;
        font-size: 14px;
        color: #747b86;
      }
    }
  }
}
</style>
